// extracted by mini-css-extract-plugin
module.exports = {"abrirPreguntasFrecuentes":"PreguntasFrecuentes_abrirPreguntasFrecuentes__3nvfC"};